import { v4 as uuidv4 } from "uuid";

export function randomInt(min, max) {
	return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function randomList(source, len) {
	const target = [];
	for (let index = 0; index < len; index++) {
		const i = randomInt(0, source.length - 1);
		target.push(source[i]);
	}
	return target;
}

export const getUUID = () => {
	//1.先判断本地存储是否存在uuid
	let uuid_token = localStorage.getItem("TOKEN");
	//如果没有则生成
	if (!uuid_token) {
		uuid_token = uuidv4();
		localStorage.setItem("TOKEN", uuid_token);
	}
	return uuid_token;
};

export function encodeSearchParams(obj) {
	const params = [];

	Object.keys(obj).forEach((key) => {
		let value = obj[key];
		if (typeof value === "undefined") {
			value = "";
		}
		// 对于需要编码的文本（比如说中文）我们要进行编码
		params.push([key, encodeURIComponent(value)].join("="));
	});

	return params.join("&");
}

export function checkMobile(phone) {
	var reg = /^1[3456789]\d{9}$/;
	return reg.test(phone);
}

export function checkName(name) {
	var reg = /^[\u4e00-\u9fa5]{2,6}$/;
	return reg.test(name);
}

/**
 * 转换ISO时间为 "YYYY-MM-DD 00:00:00" 格式
 * @param {string} isoTime - 接口返回的ISO格式时间（如2025-12-12T03:40:13.000000Z）2026-01-12T07:11:00.000000Z
 * @returns {string} 格式化后的时间（如2025-12-12 00:00:00）
 */
// export function formatIsoToDateStart(isoTime) {
// 	if (!isoTime) return ''
// 	const date = new Date(isoTime)
// 	const year = date.getFullYear()
//   const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从0开始，需+1
//   const day = String(date.getDate()).padStart(2, '0')
// 	return `${year}-${month}-${day} 00:00:00`
// }
export function formatIsoToDateStart(isoStr) {
	if (!isoStr) return ''; // 处理空值
	
	// 创建 Date 对象，自动解析 ISO 格式
	const date = new Date(isoStr);
	
	// 补零函数：确保数字是两位数（比如 7 → 07，1 → 01）
	const padZero = (num) => num.toString().padStart(2, '0');
	
	// 提取年月日时分秒
	const year = date.getFullYear();
	const month = padZero(date.getMonth() + 1); // 月份从 0 开始，需 +1
	const day = padZero(date.getDate());
	const hour = padZero(date.getHours());
	const minute = padZero(date.getMinutes());
	const second = padZero(date.getSeconds());
	
	// 拼接成目标格式（可根据需求调整，比如 "2026-01-12 07:11:00"）
	return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}
